import HeroLeft from "./HeroLeft";
import HeroVisual from "./HeroVisual";
import bio from "../../data/bio";
import socials from "../../data/socials";
import tags from "../../data/tags";

function Hero() {
  return (
    <section className="hero" id="about">
      <HeroLeft bio={bio} socials={socials} tags={tags} />
      <HeroVisual
        badgeTitle="Computer Science"
        years={"2017 - 2021"}
        img="/ricardo_martins.jpg"
        imgAlt="Ricardo Martins"
      />
    </section>
  );
}

export default Hero;
